import { useWidgetContext } from 'widget/widget-context';

const getWhatcrmApiUrl = () => {
  const topLevelDomain = window.location.hostname.split('.').at(-1);

  if (topLevelDomain == 'ru')
    return process.env.REACT_APP_WHATCRM_API_RU ?? 'https://api.whatcrm.ru';

  return process.env.REACT_APP_WHATCRM_API ?? 'https://api.whatcrm.net';
};

const useUrl = () => {
  const { platform } = useWidgetContext();

  const topLevelDomain = platform == 'ru' ? 'ru' : 'net';

  const API_URL = `https://chat.whatcrm.${topLevelDomain}/api`;
  const WHATCRM_API = getWhatcrmApiUrl();
  const WS_URL = `wss://chat.whatcrm.${topLevelDomain}/ws/`;

  return { API_URL, WHATCRM_API, WS_URL };
};

export default useUrl;
